/**
 * WHAT LEVERI CHARGES FOR, AND WHAT A FIRM HAS USED (ADR-0022).
 *
 * The unit is WORK DONE: an ACTIVE CLIENT-MONTH — a client for whom Leveri
 * prepared something (a workpaper version) in a calendar month. Never people,
 * never tokens, never questions, corrections, re-runs or reviews: those are
 * free, because they are exactly what teaches Leveri.
 *
 * The price book is DATA, versioned like a policy (`leveri.pricebook@1`).
 * Its numbers are the launch hypothesis (ADR-0022, decided by delegation on
 * 2026-10-11) and are tested by the meter from day one; changing them is a new
 * price book, never an edit of this one.
 */
import { z } from "zod";
export const PRICE_BOOK = Object.freeze({
    ref: "leveri.pricebook@1",
    currency: "USD",
    plans: Object.freeze([
        Object.freeze({ key: "FREE", name: "Free", monthlyMinor: 0, includedClientMonths: 2, extraClientMonthMinor: null }),
        Object.freeze({ key: "PRACTICE", name: "Practice", monthlyMinor: 3900, includedClientMonths: 10, extraClientMonthMinor: 400 }),
        Object.freeze({ key: "FIRM", name: "Firm", monthlyMinor: 19900, includedClientMonths: 75, extraClientMonthMinor: 300 }),
    ]),
});
/** The cheapest plan that covers a month's client-months, and what it costs — the meter's "at list price". */
export function listPriceFor(clientMonths) {
    const options = PRICE_BOOK.plans
        .filter((p) => p.extraClientMonthMinor !== null || clientMonths <= p.includedClientMonths)
        .map((p) => ({ plan: p, amountMinor: p.monthlyMinor + Math.max(0, clientMonths - p.includedClientMonths) * (p.extraClientMonthMinor ?? 0) }));
    return options.sort((a, b) => a.amountMinor - b.amountMinor)[0];
}
export const FirmUsageResponse = z.object({
    month: z.string(),
    monthLabel: z.string(),
    /** Clients for whom Leveri prepared something this month: the unit Leveri charges for. */
    clientMonths: z.number().int().nonnegative(),
    works: z.number().int().nonnegative(),
    versions: z.number().int().nonnegative(),
    clients: z.array(z.object({ clientId: z.string(), clientName: z.string(), works: z.number().int(), versions: z.number().int() })),
    /** Readings by a hosted model this month, and what they used — Leveri's own rules cost nothing and are not counted. */
    readings: z.object({ count: z.number().int(), inputTokens: z.number().int(), outputTokens: z.number().int(), tokensText: z.string() }),
    priceBook: z.string(),
    listPrice: z.object({ planName: z.string(), amountText: z.string(), includedClientMonths: z.number().int() }),
    /** Where the firm stands: during the private beta nothing is charged. */
    standing: z.string(),
});
//# sourceMappingURL=usage.js.map